

import React from "react";
import {
  Box,
  Button,
  Typography,
  useTheme,
  useMediaQuery,
  Stack,
  CardMedia,
  keyframes,
} from "@mui/material";
import Img1 from "./img/Contact Manag1.png";
import img6 from "./img/Contact management 77.png";
import { useNavigate } from "react-router-dom";

const fadeInTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-30px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const Card3 = () => {
  const theme = useTheme();
  const navigate = useNavigate();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("xs", "sm"));
  const isMd = useMediaQuery(theme.breakpoints.between("sm", "md"));
  const isLg = useMediaQuery(theme.breakpoints.between("md", "lg"));
  const isXl = useMediaQuery(theme.breakpoints.up("lg"));
  const handleClick1 = () => {
    // navigate("/solution1");
    navigate("/products", { state: { index: 1 } });
  };
  return (
    <Box
      sx={{
        animation: `${fadeInTop} 1s ease-in-out`,
        display: "flex",
        flexDirection: { xl: "row", lg: "row", md: "row", sm: "row" },
        alignItems: "center",
        backgroundColor: "#EAFBF1",
        color: "#FFFFFF",
        borderRadius: "8px",
        overflow: "hidden",
        // padding: isMd || isSm || isXs ? "12px" : "12px",
        width: "100%",
        // border: "1px solid #708f9e",
        position: "relative", // Enable positioning for the bottom-right image
        height: { xl: "380px", lg: "308px", md: "308px", xs: "200px" }, // Adjust the height of the card as needed
        marginTop: { xl: "0px", lg: "0px", md: "0px", sm: "0px", xs: "0px" },
      }}
    >
      {/* Text Section */}
      <Box
        sx={{
          height: "100%",
          width: { xl: "50%", lg: "50%", md: "100%", sm: "100%", xs: "100%" },
          // border: "2px solid blue"
          backgroundColor: "#EAFBF1",
          display: "flex",
          flexDirection: "column",
          gap: 1,
        }}
      >
        <Stack
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 1,
            // border: "1px solid red",
            justifyContent: "flex-start",
            marginLeft: "8px",
            marginTop: { xl: "8px", lg: "8px", md: "12px" },
          }}
        >
          <Stack
            sx={{
              display: "flex",
              flexDirection: "column",
              gap: 1,
              // border: "2px solid green",
              // alignItems: "center",
              justifyContent: "flex-start",
            }}
          >
            <Stack
              sx={{
                height: "80px",
                width: "80px",
                // border: "1px solid red",
              }}
            >
              <img
                src={Img1}
                alt="Forex Management"
                style={{
                  width: "90%", // Image takes full width
                  height: "90%",
                  // padding: "4px",
                  padding: isXs
                    ? "0px"
                    : isSm
                      ? "0px"
                      : isMd
                        ? "8px"
                        : isLg
                          ? "8px"
                          : "8px",
                  objectFit: "contain",
                }}
              />
            </Stack>
          </Stack>
          <Stack
            sx={{
              fontSize: {
                lg: "27px",
                xl: "27px",
                md: "27px",
                xs: "18px",
                sm: "28px",
              },
              lineHeight: {
                lg: "30px",
                xl: "30px",
                md: "30px",
                xs: "23px",
                sm: "36px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: "600",
              color: "rgba(12, 12, 12, 0.8)",
              fontFamily: "'Roboto', sans-serif",
              textAlign: "left",
              // border: "1px solid blue",
              marginLeft: "8px",
            }}
          >
            {" "}
            Advanced contact management
          </Stack>
          <Stack
            sx={{
              display: "flex",
              flexDirection: "row",
              gap: 1,
              lineHeight: {
                lg: "21px",
                xl: "21px",
                md: "21px",
                xs: "20px",
                sm: "20px",
              },
              // fontSize: "18px",
              fontSize: {
                lg: "17px",
                xl: "17px",
                md: "17px",
                xs: "16px",
                sm: "20px",
              },
              fontFamily: "'Roboto', sans-serif",
              fontWeight: {
                lg: "400",
                xl: "400",
                xs: "400",
                sm: "400",
              },
              color: "text.secondary",
              marginLeft: "8px",
              marginRight: "4px",
              fontWeight: {
                lg: 400,
                xl: 400,
                xs: 400,
                sm: 400,
              },
            }}
          >
            <Stack
              sx={{
                display: {
                  xl: "flex",
                  lg: "flex",
                  md: "none",
                  sm: "none",
                  xs: "none",
                },
              }}
            >
              {/* Organize, segmentand manage customer contacts to turn leads into
              loyal customers with ease. */}
              Organize and segment your audience with custom tags, dynamic lists and automated syncing for precise targeting and personalized campaigns.
            </Stack>
            <Stack
              sx={{
                display: {
                  xl: "none",
                  lg: "none",
                  md: "flex",
                  sm: "none",
                  xs: "none",
                },
              }}
            >
              {/* Organize, segmentand manage customer contacts to turn leads into
              loyal customers with ease. */}
              Easily organize and efficiently manage customer contacts to turn
              leads into loyal customers with ease.
            </Stack>
          </Stack>
          <Stack sx={{ display: "flex", flexDirection: "row", gap: 1 }}>
            <Stack>
              <Button
                variant="outlined"
                sx={{
                  color: "rgb(5, 78, 146)",
                  border: "1px solid rgb(5, 78, 146)",

                  "&:hover": {
                    color: "rgb(31, 133, 192)", // Hover background
                    borderColor: "rgb(31, 133, 192)", // Hover border

                  },
                  textTransform: "none",
                  fontSize: isMd || isSm || isXs ? "12px" : "16px",
                  width: "fit-content",
                  borderRadius: "8px",
                  marginLeft: "8px",
                  marginTop: {
                    xl: "4px",
                    lg: "4px",
                    md: "0px",
                    sm: "0px",
                    xs: "12px",
                  },
                  display: "none",
                }}
                size="small"
                onClick={handleClick1}
              >
                Know More
              </Button>
            </Stack>
          </Stack>
        </Stack>
      </Box>
      <Box
        sx={{
          height: "100%",
          width: "50%",
          // border: "1px solid red",
          display: {
            xl: "flex",
            lg: "flex",
            md: "none",
            sm: "none",
            xs: "none",
          },

          backgroundColor: "#EAFBF1",
        }}
      >
        <CardMedia
          component="img"
          image={img6}
          alt="card1Img"
          sx={{ height: "100%", width: "100%", objectFit: "contain" }}
        />
      </Box>
    </Box>
  );
};

export default Card3;
